/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AnonymizationServiceSignedUrl } from '../models/AnonymizationServiceSignedUrl';
import type { GenerateSignedUrl } from '../models/GenerateSignedUrl';
import type { SignedUrl } from '../models/SignedUrl';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UploadService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Generate a signed upload URL and storage path for a file. For external audio uploads, set `file_type=recording` and `recording_source=external`. For in-app recordings, set `file_type=recording` and `recording_source=app`. Supported recording MIME types: audio/mpeg, audio/wav, audio/x-wav, audio/aac, audio/mp4, video/mp4, audio/webm, audio/webm;codecs=opus. The returned `file_path` will include the source namespace (e.g. patient-recordings/external/... or patient-recordings/app/...). Use `file_type=form_template` with `content_type=application/pdf` for PDF form templates. Recording file size is validated when creating a recording resource (MAX_RECORDING_FILE_SIZE_BYTES).
     * @returns SignedUrl
     * @throws ApiError
     */
    public uploadCreate({
        requestBody,
    }: {
        requestBody: GenerateSignedUrl,
    }): CancelablePromise<SignedUrl> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/upload/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns AnonymizationServiceSignedUrl
     * @throws ApiError
     */
    public uploadAnonymizationSignedUrlCreate(): CancelablePromise<AnonymizationServiceSignedUrl> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/upload/anonymization/signed-url/',
        });
    }
}
